<template>
  <div class="actions-wrapper">
    <div>
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            dark
            v-bind="attrs"
            v-on="on"
          >
            Actions
          </v-btn>
        </template>
        <v-list>
          <actions-link-list-item
            v-for="(action, idx) in actions"
            :key="idx"
            :action="action"
            :params="params"
          />
        </v-list>
      </v-menu>
    </div>
  </div>
</template>

<script>
import cellRendererMixin from '../../mixins/cellRenderer.mixin'
import ActionsLinkListItem from './actions-link-list-item.vue'

export default {
  components: {
    ActionsLinkListItem
  },
  mixins: [cellRendererMixin],
  computed: {
    actions() {
      return this.params.colDef.actions
    }
  }
}
</script>

<style lang="scss" scoped>
  .action-link {
    cursor: pointer;
    text-decoration: none;
  }
</style>
